export class QuantronAccessInfo {
  Lambda_Polling_Url: string;
  Lambda_Main_Url: string;
  Api_Key: string;
  Widget_Config_Script_Url: string;
  Widget_Main_Script_Url: string;
  access: boolean;
  isWidgetEnable: boolean;

  constructor() {
    this.Lambda_Polling_Url = '';
    this.Lambda_Main_Url = '';
    this.Api_Key = '';
    this.Widget_Config_Script_Url = '';
    this.Widget_Main_Script_Url = '';
    this.access = false;
    this.isWidgetEnable = false;
  }
}

export class queryResultsTable {
  columns: string[];
  data: any[][];
  row_count: number;

  constructor() {
    this.columns = [];
    this.data = [];
    this.row_count = 0;
  }
}

export class HtmlMessageDetail {
  minResumeHtml: string;
  minTableResumeHtml: string;
  minChartResumeHtml: string;
  chartBase64: string;
  chartsBase64: string[];
  chartStatus: string;
  btnFullDetailEnabled: boolean;

  minOperationsTableResumeHtml: string;
  minFinanceTableResumeHtml: string;
  minSingleTableResumeHtml: string;

  dataIsVisible: boolean;
  insightsIsVisible: boolean;
  chartsIsVisible: boolean;

  dataShown: boolean;
  insightsFastShown: boolean;
  chartsFastShown: boolean;
  insightsCompleteShown: boolean;
  chartsCompleteShown: boolean;

  /* Status Varibles Progressive Cards */
  /* 
      0 = Loading
      1 = Fast
      2 = Ready
  */
  dataCardStatus: number;
  insightsCardStatus: number;
  chartsCardStatus: number;

  insights_fast: string;
  insights: string;
  charts_fast: any[];
  charts: any[];
  formatted_table_finance: string;
  formatted_table_operations: string;
  is_multi_domain: boolean;

  query_results_finance: queryResultsTable;
  query_results_operations: queryResultsTable;

  constructor() {
    this.minResumeHtml = '';
    this.minTableResumeHtml = '';
    this.minChartResumeHtml = '';
    this.chartBase64 = '';
    this.chartsBase64 = [];
    this.chartStatus = '';
    this.btnFullDetailEnabled = false;
    this.minOperationsTableResumeHtml = '';
    this.minFinanceTableResumeHtml = '';
    this.minSingleTableResumeHtml = '';
    this.dataIsVisible = false;
    this.insightsIsVisible = false;
    this.chartsIsVisible = false;
    this.dataShown = false;
    this.insightsFastShown = false;
    this.chartsFastShown = false;
    this.insightsCompleteShown = false;
    this.chartsCompleteShown = false;

    this.dataCardStatus = 0;
    this.insightsCardStatus = 0;
    this.chartsCardStatus = 0;

    this.insights_fast = '';
    this.insights = '';
    this.charts_fast = [];
    this.charts = [];
    this.formatted_table_finance = '';
    this.formatted_table_operations = '';
    this.is_multi_domain = false;

    this.query_results_finance = new queryResultsTable();
    this.query_results_operations = new queryResultsTable();
  }
}

export interface Message {
  text: string;
  messageKey: string;
  isUser: boolean;
  timestamp: Date;
  htmlMessageDetail: HtmlMessageDetail;
}

export interface FullMessageResponse {
  insights: string;
  operationsTable: string;
  financeTable: string;
  singleTable: string;
  chartBase64: string;
  chartsBase64: string[];
}

export class questionServiceResponse {
  execution_id: string;
  session_id: string;
  status: string;
  intent_type: string;
  is_multi_domain: boolean;
  formatted_table_finance: string;
  formatted_table_operations: string;
  general_answer: string;
  insights_fast: string;
  insights: string;
  charts_fast: any[];
  charts_fast_status: string;
  charts: any[];
  charts_status: string;

  constructor() {
    this.execution_id = '';
    this.session_id = '';
    this.status = '';
    this.intent_type = '';
    this.is_multi_domain = false;
    this.formatted_table_finance = '';
    this.formatted_table_operations = '';
    this.general_answer = '';
    this.insights_fast = '';
    this.insights = '';
    this.charts_fast = [];
    this.charts_fast_status = '';
    this.charts = [];
    this.charts_status = '';
  }
}